<div class="breadcrumbs hotel_banner" style="padding-top: 80px;">
    <div class="container">
      <div class="text-center breadcrumbs-item">
        <img style="width: 61vh;padding-bottom: 5px;" src="assets/images/coming-soon.png">   
      </div>
    </div>
  </div>